<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    selectable
    @update:selected="(x) => (selectedIds = x)"
    @rowClicked="showRowDetails"
  >
    <template v-slot:topbar-actions>
      <DetailsDialog ref="detailsDialog" />
      <v-spacer />
      <v-btn color="primary" @click="newUser">
        Novo Usuário...
      </v-btn>
      <OMenuButton :menuOpts="menuOpts" />
    </template>
  </GenericReport>
</template>

<script>
import { OrgApi } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import utils from 'oderon-commons/src/utils.js'
import DetailsDialog from './users/DetailsDialog.vue'

export default {
  expose: ['reload'],
  tabTitle: 'Usuários',
  components: {
    GenericReport,
    DetailsDialog
  },
  props: { value: { required: true } },
  data() {
    return {
      adapterSpec: [
        { t: 'ID|', d: 'id', selectable: true, w: 100 },
        { t: 'Login', d: 'login' },
        { t: 'Nome', d: 'name' },
        { t: 'Email', d: 'email' },
        { t: 'Tags', d: 'tags', selectable: true },
        { t: 'Perfis', d: (row) => row.profiles.map((p) => p.label) },
        { t: 'Criado em', d: 'createdAt', f: { brDt: 'YYYY-MM-DD' } }
      ],
      reportSpec: {
        title: 'Usuários',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          }
        ]
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Remover...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  watch: {
    value() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData(ps) {
      let fetcher = new OrgApi(this.value.id)
      let res = await fetcher.get('users', { skipCount: true })
      let k = ps.keywords
      res = res.filter((x) => utils.matchAnyLike(k, x.login, x.name, x.email))
      return res
    },

    async showRowDetails({ row }) {
      let res = await this.$refs.detailsDialog.open(this.value.id, row.id)
      if (res === true) {
        this.reload()
      }
    },

    async newUser() {
      let label = 'Digite o login do novo usuário:'
      let login = await this.$prompt({ label })

      if (!utils.isEmpty(login)) {
        this.$rootLoading(async () => {
          login = login.trim()
          let fetcher = new OrgApi(this.value.id)
          let created = await fetcher.post('users', { name: login, login })
          this.showRowDetails({ row: created })
          this.$snack('Criado com sucesso')
        })
      }
    },

    async confirmDelete() {
      let ok = await this.$confirmDelete({
        strings: 'usuário;o',
        len: this.selectedIds.length
      })

      if (ok) {
        this.$loading(async () => {
          let fetcher = new OrgApi(this.value.id)
          for (let x of this.selectedIds) {
            await fetcher.delete(`users/${x}`)
          }
          this.reload()
        })
      }
    }
  }
}
</script>

<style></style>
